import { apiClient, fastApiClient } from "../App";

// Get All Offenders
export const getOffenders = (params) => {
  return fastApiClient.get("/dashboard/offenders", { params });
};